import { ISPLCContacts } from "../types";
import CarrierContacts from "./CarrierContacts";
interface CarrierSPLCContactProps {
  splcContacts?: Array<ISPLCContacts>;
}
const defaultContact = [
  {
    parentRow: true,
    tableName: "splcContacts",
  },
] as Array<ISPLCContacts>;
const CarrierSPLCContact = ({
  splcContacts = defaultContact,
}: CarrierSPLCContactProps): JSX.Element => {
  return (
    <div className="mt-2 bg-white box-shadow rounded-lg h-full pb-4">
      <div className="px-3 py-2 text-primary font-bold text text-xs">
        SPLC Contact
      </div>
      <CarrierContacts carrierContacts={splcContacts} />
    </div>
  );
};

export default CarrierSPLCContact;
